export default "__VITE_ASSET__a945362b__"